export default interface UserModel {
    ip: string;
    userAgent: string;
    dimensions: [number, number];
    timeZone: number;
    language: string;
    colorDepth: number;
    canvas: string;
}

export function userToString(user: UserModel): string {
    if (user.userAgent) {
        
    }
    return user.userAgent.toString() + user.dimensions.toString() + user.timeZone.toString() + user.language + user.colorDepth.toString() + user.canvas;
}